import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { IWorkResource } from "../../../../common/data/dtos/work-resource";
import WorkResourceEnum from "../../../../common/data/enums/enumWorkResouce";
import Badge from "../../../../components/bootstrap/Badge";
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from "../../../../components/bootstrap/Card";
import { showWarning } from "../../../../components/extras/Notifications";
import PaginationButtons, { dataPagination, PER_COUNT } from "../../../../components/PaginationButtons";
import workResourceService from "../../../../services/work-resource-service";
import LoadingPage from "../../loading/LoadingPage";

export const CommonExpiringWorkResourceList = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(PER_COUNT['10']);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = useState(false);

    const [workResources, setWorkResources] = useState<IWorkResource[]>([]);


    useEffect(() => {
        fetchExpiringWorkResources();
    }, []);

    const fetchExpiringWorkResources = async () => {
        setIsLoading(true);

        const response = await workResourceService.getExpiringWorkResourcesByDueDate(30);

        setIsLoading(false);

        if (response.error) {
            showWarning(response.error);
            return;
        }

        setWorkResources(response.workResources || []);
    };

    if (isLoading) {
        return <LoadingPage />;
    }

    return(
        <>
			<Card style={{ minHeight: 600 }}>
				<CardHeader borderSize={1}>
					<CardLabel icon='CalendarToday' iconColor='primary'>
						<CardTitle tag='div' className='h5'>
							Vencimento de ferramentas e EPI
						</CardTitle>
					</CardLabel>
				</CardHeader>
				<CardBody className='table-responsive'>
					<table className='table table-modern table-hover'>
						<thead>
							<tr>
								<th>Descrição</th>
								<th>Vencimento</th>
                                <th>CA</th>
								<th>Fabricante</th>
                                <th>Tipo</th>
								<th>Situação</th>
							</tr>
						</thead>
						<tbody>
							{dataPagination(workResources, currentPage, perPage).map((item: IWorkResource) => (
								<tr key={item.id}>
									<td>{item.description}</td>
									<td>{item.dueDate ? dayjs(item.dueDate).format('DD/MM/YYYY') : '-'}</td>
                                    <td>{item.approvalCertificate}</td>
									<td>{item.manufacturer || '-'}</td>
                                    <td>
										{item.type === WorkResourceEnum.tool ? (
											<h5>
												<Badge color='info' className='align-items-center justify-content-center'>
													Ferramenta
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='info' className='align-items-center justify-content-center'>
													EPI
												</Badge>
											</h5>
										)}
									</td>
									<td>
										{item.status ? (
											<h5>
												<Badge color='success' className='align-items-center justify-content-center'>
													Ativo
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='danger' className='align-items-center justify-content-center'>
													Inativo
												</Badge>
											</h5>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</CardBody>
				<PaginationButtons data={workResources} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
			</Card>
		</>
    );
}